import moment from 'moment';

import { RefObject, useEffect, useState } from 'react';
import { Form, Input, Select } from 'antd';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { ICarsDriver } from '@common-types';
import { RootState, checkInLatinLetters, insertSpacesInPhone } from '@share/utils';
import { DATE_FORMAT_FILTER, countriesCode } from '@share/constants';

import { ICarDetails } from '@share/common-types';
import { FormInstance } from 'antd/lib/form';
import { connect } from 'react-redux';
import { ICarsReviewBookState, setCarsDriver } from '@store/slices';
import { ILoginState } from '@share/store/slices';
import { CustomDatePicker, MemberChangeValue, SavedMembers } from '@components';

import './style.scss';
import { debounce, isEmpty } from 'lodash';

interface IMapStateToProps {
  carsReviewBookStore: ICarsReviewBookState;
  loginStore: ILoginState;
}

interface IMapDispatchToProps {
  setDriver: (driver: ICarsDriver) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, WrappedComponentProps {
  car: ICarDetails;

  formRef: RefObject<FormInstance>;
  emailRef: RefObject<FormInstance>;
  handleDriverFormValidation: (driverForm: boolean) => void;
  isEmailChanging: (isEmailChanging: string | undefined) => void;

  disabled?: boolean;
}

const MAX_LENGTH_NUMBER = 12;
const MIN_LENGTH_NAME = 2;

function DriverInformationComponent(props: IProps) {
  
  const setDriverData = (value: string, key: string) => {
    const item = { ...props.carsReviewBookStore.driver, [key]: value };
    props.setDriver(item);
  };

  const {
    formRef,
    intl,
    disabled,
    carsReviewBookStore,
    loginStore,
    handleDriverFormValidation,
    emailRef,
    isEmailChanging
  } = props;

  const onChangeSavedMmeber = (selection: MemberChangeValue) => {
    const matchPhone = selection.phone ? insertSpacesInPhone(selection.phone) : undefined;
    const phone = matchPhone ? matchPhone.join('-').trim() : matchPhone;

    const item = {
      ...props.carsReviewBookStore.driver,
      givenName: selection.firstName as string,
      surname: selection.lastName as string,
      phone: phone as string,
      email: selection.email as string,
    };

    props.setDriver(item);

    formRef?.current?.setFieldsValue({
      mainDriverGivenName: selection.firstName as string,
      mainDriverSurname: selection.lastName as string,
      mainDriverPhone: phone as string
    });

    emailRef?.current?.setFieldsValue({
      email: selection.email
    });

    isEmailChanging(selection.email);

    checkFormValidity();
  }

  const { driver } = carsReviewBookStore;
  const { account } = loginStore;

  const generalBorderRadius: any = account?.generalBorderRadius ? account?.generalBorderRadius : null;
  const style = !isEmpty(generalBorderRadius) ? { borderRadius: generalBorderRadius } : {}; 
  
  const [isFormValid, setIsFormValid] = useState(false);

  const checkFormValidity = debounce(() => {
    if (!formRef.current) return;
  
    // Get only errors from visible fields (excluding saveCard and country)
    const hasErrors = formRef.current
      .getFieldsError()
      .some(({ errors }) => errors.length > 0);
  
    // Get the current field values
    const allFields = formRef.current.getFieldsValue();

    // Manually exclude saveCard and country from validation
    const filteredFields = Object.keys(allFields)
      .filter(key => key !== "mainDriverCountry")
      .reduce((obj, key) => {
        obj[key] = allFields[key];
        return obj;
      }, {});
  
    // Check if all visible fields are either user-filled or pre-filled from sessionStorage
    const allFieldsFilled = Object.entries(filteredFields).every(([key, value]) => {
      return value !== undefined && value !== ""; // Ensure the field is filled
    });
    
    // Update the button state
    setIsFormValid(!hasErrors && allFieldsFilled);
  }, 500);

  useEffect(() => {
    handleDriverFormValidation(isFormValid);
  }, [isFormValid]);

  return (
    <div className="hotel-info cars-driver-information">
      <div className="cars-driver-information__container">

        <SavedMembers onMemberChange={onChangeSavedMmeber} className="saved-members" />
        
        <div className="guest__info">
          {/* <p className="guest__title">
            <FormattedMessage id="tab.driver" />
          </p> */}
          <Form
              name="driver_information_rule"
              className="driver_information__rule"
              layout="vertical"
              ref={formRef}
              onFieldsChange={checkFormValidity}
              initialValues={{
                mainDriverCountry: 'US'
              }}
            >
            <div className="guest__rule">
              <div className="guest__info-wrapper cars-driver-information__info-wrapper">
                <Form.Item
                  label={<FormattedMessage id="first.name" />}
                  name="mainDriverGivenName"
                  className="given-name"
                  rules={[
                    {
                      required: true,
                      pattern: checkInLatinLetters,
                      message: intl.formatMessage({ id: 'error.message.contact.name' }),
                    },
                    {
                      min: MIN_LENGTH_NAME,
                      message: intl.formatMessage({ id: 'error.message.min' }, { min: MIN_LENGTH_NAME }),
                    },
                  ]}
                >
                  {/* <div className="guest__name-input-wrapper" style={style}> */}
                    {/* <span className="guest__input-label">
                      <FormattedMessage id="first.name" />
                    </span> */}
                    {/* <div className="guest__input"> */}
                      <Input
                        placeholder={intl.formatMessage({ id: 'first.name' })}
                        value={driver?.givenName}
                        maxLength={255}
                        disabled={disabled}
                        onChange={(e) => setDriverData(e.target.value, 'givenName')}
                        className='form-control form-control-lg'
                      />
                    {/* </div> */}
                  {/* </div> */}
                </Form.Item>
                <Form.Item
                  label={<FormattedMessage id="last.name" />}
                  name="mainDriverSurname"
                  className="last-name"
                  rules={[
                    {
                      required: true,
                      pattern: checkInLatinLetters,
                      message: intl.formatMessage({ id: 'error.message.contact.name' }),
                    },
                    {
                      min: MIN_LENGTH_NAME,
                      message: intl.formatMessage({ id: 'error.message.min' }, { min: MIN_LENGTH_NAME }),
                    },
                ]}
                >
                  {/* <div className="guest__name-input-wrapper" style={style}>
                    <span className="guest__input-label">
                      <FormattedMessage id="last.name" />
                    </span>
                    <div className="guest__input"> */}
                      <Input
                        placeholder={intl.formatMessage({ id: 'last.name' })}
                        value={driver?.surname}
                        maxLength={255}
                        disabled={disabled}
                        onChange={(e) => setDriverData(e.target.value, 'surname')}
                        className='form-control form-control-lg'
                      />
                    {/* </div>
                  </div> */}
                </Form.Item>
              </div>

              <div className="guest__info-wrapper cars-driver-information__info-wrapper">
                <Form.Item
                  label={<FormattedMessage id="country" />}
                  name="mainDriverCountry"
                  className="country-address"
                >
                  {/* <div className="guest__name-input-wrapper" style={style}>
                    <span className="guest__input-label">
                      <FormattedMessage id="country" />
                    </span>
                    <div className="guest__input"> */}
                      <Select 
                        value={driver?.country}
                        onChange={(e) => setDriverData(e, 'country')}
                        disabled={disabled}
                        className='customSelect'
                        optionFilterProp="label"
                        showSearch={true}
                        options={countriesCode.map(code => ({
                          value: code.isoCode,
                          label: code.name
                        }))}  
                      >
                      </Select>
                    {/* </div>
                  </div> */}
                </Form.Item>
                <Form.Item
                  label={<FormattedMessage id="birth.date" />}
                  name="mainDriverBirthDate"
                  className="birth-date"
                  initialValue={driver?.birthDate}
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({ id: 'error.message.birth_date' }),
                    },
                  ]}
                >
                  {/* <div className="guest__name-input-wrapper" style={style}>
                    <span className="guest__input-label">
                      <FormattedMessage id="birth.date" />
                    </span>
                    <div className="guest__input"> */}
                      <CustomDatePicker
                        value={driver?.birthDate}
                        placeholder={DATE_FORMAT_FILTER}
                        format={DATE_FORMAT_FILTER}
                        disabled={disabled as boolean}
                        onDateChange={(mainDriverBirthDate) => {
                          checkFormValidity();
                          setDriverData(mainDriverBirthDate, 'birthDate');
                          formRef.current?.setFieldsValue({ mainDriverBirthDate });
                        }}
                        maxDate={moment().add(-15, 'years').toDate()}
                        allowClear
                      />
                    {/* </div>
                  </div> */}
                </Form.Item>
              </div>

              <div className="guest__info-phone-wrapper">
                <Form.Item
                  label={<FormattedMessage id="mobile.phone" />}
                  name="mainDriverPhone"
                  validateTrigger="onBlur"
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: intl.formatMessage({ id: 'error.message.phone' }),
                    },
                    {
                      max: MAX_LENGTH_NUMBER,
                      message: intl.formatMessage({ id: 'error.message.number.must.be' }),
                    },
                  ]}
                >
                  <div className="guest__name-input-wrapper test-test" style={style}>
                    <span className="guest__input-label">
                      <FormattedMessage id="mobile.phone" />
                    </span>
                    <div className="guest__input">
                      <Input.Group compact>
                        <Select 
                          defaultValue="United States"
                          disabled={disabled} 
                          style={{ width: '115px' }}
                          //className='customSelect'
                          optionFilterProp="label"
                          showSearch={true}
                          options={countriesCode.map(code => ({
                            value: code.name,
                            label: `${code.isoCode} ${code.dialCode}`
                          }))}  
                        >
                        </Select>
                        <Input
                          style={{ width: '50%', borderRadius: '0.5rem' }}
                          placeholder={intl.formatMessage({ id: 'phone.number' })}
                          disabled={disabled}
                          onChange={(e) => {
                            const matchPhone = insertSpacesInPhone(e.target.value) || [];

                            // Solo hace join si matchPhone tiene elementos
                            const num = matchPhone.length > 0 ? matchPhone.join('-').trim() : '';

                            setDriverData(num, 'phone');
                          }}
                          value={driver?.phone}
                          maxLength={12}
                          //className='form-control form-control-lg'
                        />
                      </Input.Group>
                    </div>
                  </div>
                </Form.Item>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    carsReviewBookStore: state.carsReviewBookStore,
    loginStore: state.loginStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  setDriver: setCarsDriver,
};

export const DriverInformation = connect(mapStateToProps, mapDispatchToProps)( injectIntl(DriverInformationComponent));
